/**
 * Summary
 * A Dropdown/Select picker for selecting a value from a list of options.
 */

// import { setOptions } from 'leaflet';
import React, { useState, useRef, useEffect } from 'react';
import { Icon } from './Icon';

export function Select(props) {
  const {
    options,
    showBullets,
    onChange,
    defaultValue,
    // title,
    keepOpen,
    disabled,
  } = props;
  let { minWidth } = props;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const [listH, setListH] = useState(0);

  const handleToggle = () => {
    if (disabled) return;
    const newState = !open;
    setOpen(newState);
  };

  const handleChange = (value) => {
    if (disabled) return;
    // console.log(value);
    setValue(value);
    if (!keepOpen) {
      setOpen(false);
    }
    if (onChange) {
      onChange(value);
    }
  };

  let classes = ['chronos-select-picker'];

  if (open) {
    classes.push(' chronos-select-opened');
  }

  if (disabled) {
    classes.push('chronos-select-disabled');
  }

  const selectRef = useRef();
  const listRef = useRef();

  // console.log(selectRef, listRef)
  minWidth = minWidth && minWidth > 0 ? minWidth : 0;
  let listHeight = 0;
  let listWidth = minWidth;

  useEffect(() => {
    if (listRef.current) {
      listHeight = -listRef.current.clientHeight;
      listWidth =
        listRef.current.clientWidth > minWidth
          ? listRef.current.clientWidth
          : minWidth;
      // console.log('Select List Width/Height', listWidth, listHeight);
      setListH(listHeight);
    }
  }, [open]);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  // console.log('Min width is ', minWidth, listWidth);

  useEffect(() => {
    const handleOutsideClick = (ev) => {
      if (selectRef.current && !selectRef.current.contains(ev.target)) {
        setOpen(false);
      }
    };

    if (open) {
      window.addEventListener('click', handleOutsideClick);
    }
    return () => window.removeEventListener('click', handleOutsideClick);
  }, [open]);

  return (
    <div
      className={classes.join(' ')}
      ref={selectRef}
      style={{ width: listWidth }}
    >
      <div className="chronos-select-value" onClick={handleToggle}>
        {value}
      </div>
      <div className="chronos-select-toggle" onClick={handleToggle}>
        <Icon icon="fas fa-triangle fa-rotate-180" />
      </div>
      <div className="chronos-select-list" ref={listRef} style={{ top: listH }}>
        {/* {title &&
          <div className="chrono-select-list-title">{title}</div>
        } */}
        {options &&
          options.map((option, index) => (
            <SelectOption
              key={index}
              bullet={showBullets}
              active={option.value === value}
              option={option}
              onChange={handleChange}
            />
          ))}
      </div>
    </div>
  );
}

function SelectOption(props) {
  const { bullet, active, option, onChange } = props;
  let classes = 'chronos-select-option';
  let bulletClasses = 'chronos-select-option-bullet';
  if (active) {
    classes += ' chronos-select-option-active';
    bulletClasses += ' chronos-select-option-bullet-active';
  }

  const handleChange = (value) => {
    onChange(value);
  };
  return (
    <div className={classes} onClick={() => handleChange(option.value)}>
      {bullet && (
        <span className={bulletClasses}>
          <Icon icon={active ? 'far fa-dot-circle' : 'far fa-circle'} />
        </span>
      )}
      <span className="chronos-select-option-display">{option.display}</span>
    </div>
  );
}
